










import { Container } from '@front/ui'
import { computed, defineComponent } from '@vue/composition-api'

import useCustomer from '@member-area/core/resources/Customer/Customer.hook'
import { UNSUBSCRIBED_CUSTOMER_STATUS } from '@member-area/core/resources/Customer/constants'
import useSubscription from '@member-area/core/resources/Subscription/Subscription.hook'

import Subscribed from './components/Subscribed'
import CustomerSupportModal from './components/Subscribed/components/CustomerSupportModal.vue'
import Unsubscribed from './components/Unsubscribed'

export default defineComponent({
  components: {
    Subscribed,
    Unsubscribed,
    CustomerSupportModal,
    Container,
  },
  setup() {
    const { customer } = useCustomer()
    const { subscription } = useSubscription()

    const isSubscribed = computed(() => {
      return customer.value?.subscriptionStatus !== UNSUBSCRIBED_CUSTOMER_STATUS
    })

    return { isSubscribed, subscription }
  },
})
